export const MINT_ACTION = 1;
export const TRANSFER_ACTION = 2;
export const APPROVE_ACTION = 3;
export const BURN_ACTION = 4;

export const ACCOUNT_TYPE = 0;
export const CONTRACT_TYPE = 1;

export interface StampAction {
  amount: number;
  ftActionTypeId: number;
  timestamp: string;
  transactionHash: string;
  sourcePublicKey: string | null;
  sourceHash: string | null;
  sourceType: number | null;
  targetPublicKey: string | null;
  targetHash: string | null;
  targetType: number | null;
}
